import React from "react"

import { css } from 'emotion'

import Header from "../components/header"
import SectionVivo from "../components/sectionVivo"
import SectionFAQ from "../components/sectionFAQ"
import SectionContacto from "../components/sectionContacto"
import Footer from "../components/footer"
import SectionConfirma from "../components/sectionConfirma"

const Home = () => {

  return (
    <>
      <Header siteTitle={ `IES21`} />
      <div
        className={css`
          margin: 0 auto;
          max-width: 1024px;
          padding: 0 1.0875rem 1.45rem;
          display: flex;
          flex-direction: column;
          margin-top: -30px;
        `}
      >
        <main
          className={css`
            border-left: 2px solid #1f517c;
            border-right: 2px solid #1f517c;
            border-bottom: 2px solid #1f517c;

        `}
        >
          <SectionConfirma />

          <SectionVivo />

          <SectionFAQ />

          <SectionContacto />
        </main>
        <Footer />
      </div>
    </>
  )
}

export default Home
